import { render, staticRenderFns } from "./covermask.vue?vue&type=template&id=1e53a384&scoped=true&"
import script from "./covermask.vue?vue&type=script&lang=js&"
export * from "./covermask.vue?vue&type=script&lang=js&"
import style0 from "./covermask.vue?vue&type=style&index=0&id=1e53a384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53a384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e53a384')) {
      api.createRecord('1e53a384', component.options)
    } else {
      api.reload('1e53a384', component.options)
    }
    module.hot.accept("./covermask.vue?vue&type=template&id=1e53a384&scoped=true&", function () {
      api.rerender('1e53a384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/covermask.vue"
export default component.exports